/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {Board, Stage} from '../model';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class BoardService {
  boards = new BehaviorSubject<Board[]>([]);
  boards$ = this.boards.asObservable();
  currentBoard = new BehaviorSubject<Board>(new Board());
  currentBoard$ = this.currentBoard.asObservable();
  constructor() {}

  setBoards(boards1: Board[]): void {
    this.boards.next(boards1);
  }

  setBoard(board: Board): void {
    this.currentBoard.next(board);
  }
}
